import React, { memo } from 'react';
import { UtilityNav } from 'web-ui-components/lib/navigation/site-navs';
import { BackButton } from 'web-ui-components/lib/molecules/navigation';
import { ContainedHeader } from 'web-ui-components/lib/layout/headers';
import { Identifier } from 'web-ui-components/lib/typography/modifiers';
import { Help } from './Help';

const UtilityNavigation = memo(function UtilityNavigation({
  backClick,
  isBackNavigationNeeded = true,
  hideHelp = false
}) {
  return (
    <UtilityNav
      leftContent={
        isBackNavigationNeeded && (
          <BackButton
            onClick={e => {
              e.preventDefault();
              backClick();
            }}
          />
        )
      }
      rightContent={!hideHelp && <Help />}
    />
  );
});

const Header = memo(function Header({ externalContent }) {
  const { defaultBusinessHeader, businessVMHeaderName, currentAccountHeader } = externalContent;
  return (
    <ContainedHeader
      subline={[
        defaultBusinessHeader,
        <Identifier.NonWrapping>{businessVMHeaderName}</Identifier.NonWrapping>,
        <Identifier.NonWrapping>{currentAccountHeader}</Identifier.NonWrapping>
      ]}
    />
  );
});

export { Header, UtilityNavigation };
